import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export class RequestIdInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (req.headers.has("X-Request-Id")) {
      return next.handle(req);
    }

    const requestId = this.generateRequestId();
    const clonedRequest = req.clone({
      setHeaders: {
        "X-Request-Id": requestId,
      },
    });

    return next.handle(clonedRequest);
  }

  private generateRequestId(): string {
    const cryptoObj = globalThis.crypto;
    if (cryptoObj?.randomUUID) {
      return cryptoObj.randomUUID();
    }

    return `req-${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }
}
